import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const WoltDriveInstallationForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<>
			<FormInput
				name="settings.venue_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.venue_id.title")}
			/>
			<FormInput
				name="settings.merchant_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.merchant_id.title")}
			/>
			<FormInput
				name="settings.api_key"
				errors={errors}
				register={register}
				label={t("modules.app.field.api_key.title")}
			/>
			<FormInput
				name="settings.support_url"
				errors={errors}
				register={register}
				label={t("modules.app.field.support_url.title")}
			/>
			<FormInput
				name="settings.support_email"
				errors={errors}
				register={register}
				label={t("modules.app.field.support_email.title")}
			/>
			<FormInput
				name="settings.support_phone_number"
				errors={errors}
				register={register}
				label={t("modules.app.field.support_phone_number.title")}
			/>
		</>
	);
};

export default WoltDriveInstallationForm;
